import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IJobsService } from "services/JobsService";
import { GuidSelectModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  JobStatusTypeSelectModels: new Array<GuidSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const jobStatusTypeSelectSlice = createSlice({
  name: "jobStatusTypeSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getSelectModels.fulfilled, (state, action) => {
        state.JobStatusTypeSelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getSelectModels = createAsyncThunk("JobStatusTypes/GetSelectModels", async () => {
  const jobStatusTypesService = container.get<IJobsService>(SERVICE_TYPES.JobsService);
  return await jobStatusTypesService.getJobStatusTypeSelectModels();
});

export const selectJobStatusTypeSelectModels = (state: RootState) => {
  return state.jobStatusTypeSelect.JobStatusTypeSelectModels;
};
export const selectLoading = (state: RootState) => {
  return state.jobStatusTypeSelect.Loading;
};
export const selectLastUpdateTime = (state: RootState) => {
  return state.jobStatusTypeSelect.LastUpdateTime;
};

export default jobStatusTypeSelectSlice.reducer;
